<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields['title']" label="Name" />
        </div>
        <div>
          <label class="label-input">Title</label>
          <ckeditor :editor="editor" v-model="fields.titleItemsGridMedia" :config="editorConfig" />
        </div>
        <div class="mt-6">
          <div class="d-flex justify-space-between align-center mb-4">
            <label class="label-input">Media</label>
            <v-btn small color="primary" @click="handleAddMedia">
              <v-icon size="16" left>mdi-plus</v-icon>
              Add Media
            </v-btn>
          </div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  type="number"
                  :rules="[
                    v => Number(v) > 0 || 'Items Per Row must be greater than 0',
                    v => Number(v) <= maxItemsPerRow || `Items Per Row must be <= ${maxItemsPerRow}`,
                  ]"
                  min="1"
                  v-model="fields.itemsPerRow.mobile"
                  label="Items Per Row (Mobile)"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  type="number"
                  :rules="[
                    v => Number(v) > 0 || 'Items Per Row must be greater than 0',
                    v => Number(v) <= maxItemsPerRow || `Items Per Row must be <= ${maxItemsPerRow}`,
                  ]"
                  min="1"
                  v-model="fields.itemsPerRow.desktop"
                  label="Items Per Row (Desktop)"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  type="number"
                  v-model.number="fields.videoHeight"
                  label="Video Height"
                  min="0"
                  suffix="px"
                  :rules="[v => v >= 0 || 'Video Height must be greater than or equal 0']"
                />
              </v-col>
            </v-row>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.mediaItems" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                      <span>Media {{ i + 1 }}</span>
                      <v-btn
                        style="color: white; font-size: 10px !important; padding: 4px 8px !important"
                        class="ml-4"
                        v-if="item.url && checkIsYoutubeUrl(item.url)"
                        color="red"
                        small
                      >
                        <v-icon class="mr-1">mdi-youtube</v-icon> Youtube
                      </v-btn>
                    </div>
                    <v-btn icon small @click.stop="handleRemoveMedia(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-flex align-center gap-6">
                    <v-text-field v-model="item.url" label="Video URL" hide-details />
                    <v-btn
                      v-if="item.url && !checkIsYoutubeUrl(item.url)"
                      @click="handlePreviewVideo(i)"
                      text
                      color="primary"
                      small
                    >
                      <v-icon>mdi-reload</v-icon> Reload
                    </v-btn>
                  </div>
                  <div class="video-wrapper" v-if="item.url && !checkIsYoutubeUrl(item.url)">
                    <div class="wrap-video">
                      <video width="100%" height="auto" autoplay muted loop playsinline :ref="`videoPlayer-${i}`">
                        <source data-attribute="card-video" type="video/mp4" :src="item.url" />
                      </video>
                    </div>
                  </div>
                  <div class="video-wrapper" v-if="item.url && checkIsYoutubeUrl(item.url)">
                    <iframe
                      width="100%"
                      height="315"
                      class="items-grid-media-item-video-inner"
                      data-attribute="items-grid-media-item-video-inner"
                      :src="normalizeYoutubeEmbedUrl(item.url)"
                      :title="item.content"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                  <div class="mt-4">
                    <label>Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <div>
              <div class="font-weight-medium">Spacing</div>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="fields.padding.top" label="Top Spacing" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Spacing" dense hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3">Container Colors</div>
              <v-row>
                <v-col cols="12" md="6">
                  <ColorPicker
                    v-model="fields.colors.backgroundColor"
                    name="backgroundColor"
                    label="Background Color"
                    default-color="#ffffff"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <ColorPicker
                    v-model="fields.colors.textColor"
                    name="textColor"
                    label="Text Color"
                    default-color="#000000"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';
import { isYoutubeUrl, normalizeYoutubeEmbedUrl } from '@/views/website/products/components/description/common/utils';

export default {
  name: 'ItemsGridMedia',
  components: {
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        titleItemsGridMedia: '',
        colors: {
          backgroundColor: '#ffffff',
          textColor: '#000000',
        },
        padding: {
          top: true,
          bottom: true,
        },
        mediaItems: [
          {
            url: '',
            content: '',
          },
        ],
        itemsPerRow: {
          mobile: 1,
          desktop: 2,
        },
        videoHeight: 315,
      },
    };
  },
  computed: {
    maxItemsPerRow() {
      return Math.max(1, this.fields.mediaItems?.length || 0);
    },
  },
  mounted() {
    if (this.sectionEditor.sectionExtract) {
      this.fields = {
        ...this.fields,
        ...this.sectionEditor.sectionExtract,
      };
      this.normalizeItemsPerRow();
    }
  },
  methods: {
    handlePreviewVideo(index) {
      const refValue = this.$refs[`videoPlayer-${index}`];
      const maybeEl = Array.isArray(refValue) ? refValue[0] : refValue;
      const videoEl = maybeEl?.$el ? maybeEl.$el : maybeEl;

      if (videoEl && typeof videoEl.load === 'function') {
        videoEl.load();
        videoEl.play?.();
      }
    },
    handleUploadImageBackground(obj) {
      if (obj && obj.imageSrc) {
        this.fields.imageBackground.desktop = obj.imageSrc;
      }
    },
    handleUploadImageBackgroundMobile(obj) {
      if (obj && obj.imageSrc) {
        this.fields.imageBackground.mobile = obj.imageSrc;
      }
    },
    handleRemoveImageBackground() {
      this.fields.imageBackground.desktop = '';
    },
    handleRemoveImageBackgroundMobile() {
      this.fields.imageBackground.mobile = '';
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionItemsGridMedia(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    checkIsYoutubeUrl(url) {
      return isYoutubeUrl(url);
    },
    normalizeYoutubeEmbedUrl(url) {
      return normalizeYoutubeEmbedUrl(url);
    },
    normalizeItemsPerRow() {
      const max = this.maxItemsPerRow;
      const mobile = Number(this.fields.itemsPerRow?.mobile);
      const desktop = Number(this.fields.itemsPerRow?.desktop);

      if (!this.fields.itemsPerRow) {
        this.$set(this.fields, 'itemsPerRow', { mobile: max, desktop: max });
        return;
      }

      const safeMobile = Number.isNaN(mobile) || mobile < 1 ? 1 : mobile;
      const safeDesktop = Number.isNaN(desktop) || desktop < 1 ? 1 : desktop;

      this.fields.itemsPerRow.mobile = Math.min(safeMobile, max);
      this.fields.itemsPerRow.desktop = Math.min(safeDesktop, max);
    },
    handleAddMedia() {
      this.fields.mediaItems.push({
        url: 'https://www.youtube-nocookie.com/embed/iQvnDIGMmwQ?rel=0',
        content: '<h2 style="text-align: center"> <strong>"Content"</strong> </h2>',
      });
    },
    handleRemoveMedia(index) {
      this.fields.mediaItems.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 100px !important;
}
::v-deep .ck-editor__editable {
  min-height: 100px !important;
}
.video-wrapper {
  margin-top: 16px;
  background: rgba(0, 0, 0, 0.767);
  .wrap-video {
    max-width: 300px;
    margin: 0 auto;
    video {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
